module.exports = __webpack_public_path__ + "static/media/theme_irland.bc884a35.jpg";